import * as React from 'react'
export const ScheduleCallIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={85} height={84} fill="none" {...props}>
    <g filter="url(#a)">
      <circle cx={42.5} cy={42} r={22} fill="#fff" />
    </g>
    <g clipPath="url(#b)">
      <path
        fill="#E12468"
        stroke="#E12468"
        d="M50.745 51.505h.001a2.75 2.75 0 0 0 2.75-2.75V42c0-6.075-4.925-11-10.998-11C36.424 31 31.5 35.925 31.5 42v2.25c0 .136-.114.25-.25.25a.252.252 0 0 1-.25-.25V42c0-6.352 5.147-11.5 11.498-11.5 6.35 0 11.498 5.148 11.502 11.5v6.755a3.253 3.253 0 0 1-3.253 3.25h-.001L46.871 52h-.354l-.118.333a1.756 1.756 0 0 1-1.652 1.167h-3a1.75 1.75 0 0 1 0-3.5h3c.76 0 1.411.488 1.652 1.167l.118.333h.353l3.875.005ZM38.5 40.5V40h-1.25a2.75 2.75 0 0 0-2.75 2.75v1.5A2.75 2.75 0 0 0 37.25 47h1.25v-6.5Zm8.498-.5h-.5v7h1.25a2.75 2.75 0 0 0 2.75-2.75v-1.5a2.75 2.75 0 0 0-2.75-2.75h-.75Zm-2.25 13c.689 0 1.25-.561 1.25-1.25s-.561-1.25-1.25-1.25h-3c-.688 0-1.25.561-1.25 1.25S41.06 53 41.748 53h3ZM34 44.25v-1.5a3.249 3.249 0 0 1 3.25-3.25h.75c.553 0 1 .446 1 1v6c0 .554-.447 1-1 1h-.75a3.249 3.249 0 0 1-3.25-3.25Zm12.998-4.75h.75a3.249 3.249 0 0 1 3.249 3.25v1.5a3.249 3.249 0 0 1-3.25 3.25h-.75c-.553 0-.999-.446-.999-1v-6c0-.554.447-1 1-1Z"
      />
    </g>
    <defs>
      <clipPath id="b">
        <path fill="#fff" d="M30.5 30h24v24h-24z" />
      </clipPath>
      <filter
        id="a"
        width={84}
        height={84}
        x={0.5}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={10} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_10204_271014" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_10204_271014" result="shape" />
      </filter>
    </defs>
  </svg>
)
